/**
 * @fileoverview ClienteRepository - Repositorio especializado para clientes
 */

import { DataRepository } from './base/DataRepository';
import type { Cliente, CreateClienteData, UpdateClienteData } from '../types/collections/Cliente';
import type { QueryOptions } from '../types/common/PocketBaseTypes';
import { RepositoryError } from '../types/common/PocketBaseTypes';

/**
 * Repositorio especializado para la gestión de clientes
 * Extiende DataRepository con métodos específicos del dominio
 */
export class ClienteRepository extends DataRepository<Cliente> {
  constructor() {
    super('cliente');
  }

  /**
   * Obtiene lista de clientes activos para autocompletado
   * Retorna solo id y razon_social ordenados alfabéticamente
   */
  async getClientesParaAutocompletado(): Promise<Cliente[]> {
    try {
      return await this.pb.collection(this.collectionName).getFullList<Cliente>({
        filter: 'activo=true',
        sort: 'razon_social',
        fields: 'id,razon_social',
      });
    } catch (error) {
      throw new RepositoryError(
        `Error al obtener clientes para autocompletado: ${error instanceof Error ? error.message : String(error)}`,
        'GET_CLIENTES_AUTOCOMPLETADO_ERROR',
        error
      );
    }
  }
}

